export type KemCardStyleKeyType =
  | 'singularity'
  | 'lime'
  | 'marine'
  | 'mystic'
  | 'magenta'
  | 'indigo'
  | 'amber'

export interface KemCardStyleItem {
  id: string
  key: KemCardStyleKeyType
  translationKey: string
  gradient: string[]
  textColor: string
}

export const kemCardStylesList: KemCardStyleItem[] = [
  {
    id: 'singularity',
    key: 'singularity',
    translationKey: 'cardStyleNames.singularity',
    gradient: ['#1a1a1a', '#2d2d2d'],
    textColor: '#ffffff',
  },
  {
    id: 'lime',
    key: 'lime',
    translationKey: 'cardStyleNames.lime',
    gradient: ['#84cc16', '#65a30d'],
    textColor: '#ffffff',
  },
  {
    id: 'marine',
    key: 'marine',
    translationKey: 'cardStyleNames.marine',
    gradient: ['#0ea5e9', '#0284c7'],
    textColor: '#ffffff',
  },
  {
    id: 'mystic',
    key: 'mystic',
    translationKey: 'cardStyleNames.mystic',
    gradient: ['#7c3aed', '#5b21b6'],
    textColor: '#ffffff',
  },
  {
    id: 'magenta',
    key: 'magenta',
    translationKey: 'cardStyleNames.magenta',
    gradient: ['#ec4899', '#db2777'],
    textColor: '#ffffff',
  },
  {
    id: 'indigo',
    key: 'indigo',
    translationKey: 'cardStyleNames.indigo',
    gradient: ['#6366f1', '#4f46e5'],
    textColor: '#ffffff',
  },
  {
    id: 'amber',
    key: 'amber',
    translationKey: 'cardStyleNames.amber',
    gradient: ['#f59e0b', '#d97706'],
    textColor: '#ffffff',
  },
]
